import { AntOptionsField } from './ant-options.field'

export class AntSelectField extends AntOptionsField {
  constructor(options: AntOptionsField) {
    super(options)
    this.selector = 'ef-ant-select'
  }
}
